/**
 * @file useCombineRef
 */
import { useCallback, useRef } from 'react';
import { assign } from '@tencent/glue-util-helper';
export function useCombineRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var ref = useRef(refs);
  ref.current = refs;
  return useCallback(function (current) {
    ref.current.forEach(function (item) {
      if (item == null) {
        return;
      }

      if (typeof item === 'function') {
        item(current);
      } else {
        assign(item, {
          current: current
        });
      }
    });
  }, []);
}